import React from 'react';
import { motion } from 'framer-motion';
import CloseIcon from '@mui/icons-material/CloseRounded';

import Backdrop from './Backdrop';
import './MessageModal.css';

const dropIn = {
  hidden: {
    y: '-100vh',
    opacity: 0,
  },
  visible: {
    y: 0, // Final position; vertical offset is controlled by the Backdrop's padding
    opacity: 1,
    transition: {
      duration: 0.1,
      type: 'spring',
      damping: 25,
      stiffness: 500,
    },
  },
  exit: {
    y: '100vh',
    opacity: 0,
  },
};

const MessageModal = ({ message, handleClose }) => {
  return (
    <Backdrop onClick={handleClose}>
      <motion.div
        onClick={(e) => e.stopPropagation()}
        className='message-modal'
        variants={dropIn}
        initial='hidden'
        animate='visible'
        exit='exit'
      >
        <CloseIcon
          className='message-modal-close-button'
          fontSize='large'
          onClick={handleClose}
        />
        <div className='message-modal-text-container'>
          <p className='message-modal-text'>{message.message}</p>
        </div>
      </motion.div>
    </Backdrop>
  );
};

export default MessageModal;
